// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import CenterWiseLoanProposalActionTypes from './center-wise-loan-proposal.types';
import {
	createNewCenterWiseLoan,
	updateCenterWiseLoan,
	fetchMembersListForCenterLoan,
	centerWiseLoanProposalDetailsFetch,
	memberBankDetailsAdd,
	memberBankDetailsFetch,
	correctLoanForOverallMemberUpdate,
	correctLoanStartEndDateForMemberUpdate,
} from './center-wise-loan-proposal.service';

import {
	addCenterWiseLoanPropsalSuccess,
	addCenterWiseLoanPropsalFailure,
	addCenterWiseLoanPropsalResponseChanged,
	updateCenterWiseLoanProposalSuccess,
	updateCenterWiseLoanProposalFailure,
	updateCenterWiseLoanProposalResponseChanged,
	fetchMembersListForCenterWiseLoanSuccess,
	fetchMembersListForCenterWiseLoanFailure,
	fetchMembersListForCenterWiseLoanResponseChanged,
	fetchCenterWiseLoanProposalFailure,
	fetchCenterWiseLoanProposalSuccess,
	fetchCenterWiseLoanProposalResponseChanged,
	addMemberbankDetailsFailure,
	addMemberbankDetailsSuccess,
	fetchMemberbankDetailsFailure,
	fetchMemberbankDetailsSuccess,
	addMemberbankDetailsResponseChanged,
	updateCorrectLoanForOverallMemberResponseChanged,
	updateCorrectLoanForOverallMemberFailure,
	updateCorrectLoanForOverallMemberSuccess,
	updateCorrectLoanStartEndDateForMemberFailure,
	updateCorrectLoanStartEndDateForMemberSuccess,
	updateCorrectLoanStartEndDateForMemberResponseChanged,
	fetchMemberbankDetailsResponseChanged,
} from './center-wise-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** ********************* START ADD BUSINESS LOAN PROPOSAL ******************** */
export function* createNewLoanProposal({ payload }: any) {
	try {
		const key = 'createLoanIndexBranchKey';
		const {
			areaId,
			branchId,
			totalLoanAmount,
			loanOfficerId,
			loanProposalDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			loanIndexType,
			loanType,
			userID,
			companyID,
			databaseName,
			funderName,
			memberLeadId,
			LoanIndexGroupMember,
			productInvestorDetails,
		} = payload;

		const jsonData = {
			AreaID: areaId,
			BranchID: branchId,
			TotalLoanAmount: totalLoanAmount,
			LoanOfficerID: loanOfficerId,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			LoanIndexType: loanIndexType,
			LoanType: loanType,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			FunderName: funderName,
			memberLeadID: memberLeadId,
			LoanIndexGroupMember: LoanIndexGroupMember,
			ProductInvestorDetails: productInvestorDetails,
		};
		console.log('jsonData', jsonData);
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createNewCenterWiseLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCenterWiseLoanPropsalFailure(responseData.data));
		} else {
			yield put(addCenterWiseLoanPropsalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCenterWiseLoanPropsalFailure(error));
	}
}

export function* resetAddCenterWiseLoanProposalResponse() {
	yield put(addCenterWiseLoanPropsalResponseChanged());
}

export function* onCreateCenterWiseLoanProposal() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_START,
		createNewLoanProposal,
	);
}

export function* onCreateCenterWiseLoanProposalResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddCenterWiseLoanProposalResponse,
	);
}
/** ********************* END ADD BUSINESS LOAN PROPOSAL ******************** */

/** ********************* START UPDATE CENTER WISE LOAN PROPOSAL ******************** */
export function* CenterWiseLoanProposal({ payload }: any) {
	try {
		const key = 'UpdateCenterWiseLoanProposalKey';
		const {
			loanIndexId,
			areaId,
			branchId,
			totalLoanAmount,
			loanOfficerId,
			loanProposalDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			loanIndexType,
			loanType,
			userID,
			companyID,
			databaseName,
			funderName,
			memberLeadId,
			LoanIndexGroupMember,
			productInvestorDetails,
		} = payload;

		const jsonData = {
			LoanIndexID: loanIndexId,
			AreaID: areaId,
			BranchID: branchId,
			TotalLoanAmount: totalLoanAmount,
			LoanOfficerID: loanOfficerId,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			LoanIndexType: loanIndexType,
			LoanType: loanType,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			FunderName: funderName,
			memberLeadID: memberLeadId,
			LoanIndexGroupMember: LoanIndexGroupMember,
			ProductInvestorDetails: productInvestorDetails,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateCenterWiseLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCenterWiseLoanProposalFailure(responseData.data));
		} else {
			yield put(updateCenterWiseLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCenterWiseLoanProposalFailure(error));
	}
}

export function* resetUpdateCenterWiseLoanProposalResponse() {
	yield put(updateCenterWiseLoanProposalResponseChanged());
}

export function* onUpdateCenterWiseLoanProposal() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_START,
		CenterWiseLoanProposal,
	);
}

export function* onUpdateCenterWiseLoanProposalResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateCenterWiseLoanProposalResponse,
	);
}
/** ********************* END UPDATE CENTER WISE LOAN PROPOSAL ******************** */

/** ********************* START FETCH MEMBERS LIST FOR CENTER WISE LOAN ******************** */
export function* fetchMembersListForCenterWiseLoanData({ payload }: any) {
	try {
		const key = 'GetCenterWiseMembersListKey';
		const { companyID, CenterID, GroupID, SearchData, Limit, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			CenterID,
			GroupID,
			SearchData,
			Limit,
			DatabaseName: databaseName,
		};
		console.log(jsonData);
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMembersListForCenterLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMembersListForCenterWiseLoanFailure(responseData.data));
		} else {
			yield put(fetchMembersListForCenterWiseLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMembersListForCenterWiseLoanFailure(error));
	}
}

export function* resetFetchMembersListForCenterWiseLoanResponse() {
	yield put(fetchMembersListForCenterWiseLoanResponseChanged());
}

export function* onFetchMembersListForCenterWiseLoanDetails() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_START,
		fetchMembersListForCenterWiseLoanData,
	);
}

export function* onFetchMembersListForCenterWiseLoanResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_RESET,
		resetFetchMembersListForCenterWiseLoanResponse,
	);
}
/** ********************* END FETCH MEMBERS LIST FOR CENTER WISE LOAN ******************** */

/** ********************* START FETCH CENTER WISE LOAN PROPOSAL ******************** */
export function* fetchCenterWiseLoanProposalData({ payload }: any) {
	try {
		const key = 'getParticularBranchLoanIndexInfoKey';
		const { companyID, loanIndexID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerWiseLoanProposalDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCenterWiseLoanProposalFailure(responseData.data));
		} else {
			yield put(fetchCenterWiseLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCenterWiseLoanProposalFailure(error));
	}
}

export function* resetFetchCenterWiseLoanProposalResponse() {
	yield put(fetchCenterWiseLoanProposalResponseChanged());
}

export function* onFetchCenterWiseLoanProposalDetails() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_START,
		fetchCenterWiseLoanProposalData,
	);
}

export function* onFetchCenterWiseLoanProposalResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetFetchCenterWiseLoanProposalResponse,
	);
}
/** ********************* END FETCH CENTER WISE LOAN PROPOSAL ******************** */

/** ********************* START ADD MEMBER BANK DETAILS ******************** */
export function* addMemberBankDetails({ payload }: any) {
	try {
		const key = 'CreateMemberBankDetailsKey';
		const {
			companyID,
			memberID,
			databaseName,
			bankName,
			bankBranchName,
			ifscCode,
			accountHolderName,
			accountType,
			accountNumber,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
			BankName: bankName,
			BranchName: bankBranchName,
			IFSCCode: ifscCode,
			AccountHolderName: accountHolderName,
			AccountType: accountType,
			AccountNumber: accountNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberBankDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberbankDetailsFailure(responseData.data));
		} else {
			yield put(addMemberbankDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberbankDetailsFailure(error));
	}
}

export function* resetAddMemberBankDetailsResponse() {
	yield put(addMemberbankDetailsResponseChanged());
}

export function* onAddMemberBankDetailsResponse() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_START,
		addMemberBankDetails,
	);
}

export function* onAddMemberBankDetailsResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_RESPONSE_RESET,
		resetAddMemberBankDetailsResponse,
	);
}
/** ********************* END ADD MEMBER BANK DETAILS ******************** */

/** ********************* START FETCH MEMBER BANK DETAILS ******************** */
export function* fetchMemberBankDetails({ payload }: any) {
	try {
		const key = 'MemberBankDetailsKey';
		const { companyID, memberID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberBankDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberbankDetailsFailure(responseData.data));
		} else {
			yield put(fetchMemberbankDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberbankDetailsFailure(error));
	}
}

export function* resetFetchMemberBankDetailsResponse() {
	yield put(fetchMemberbankDetailsResponseChanged());
}

export function* onFetchMemberBankDetailsResponse() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_START,
		fetchMemberBankDetails,
	);
}

export function* onFetchMemberBankDetailsResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_RESPONSE_RESET,
		resetFetchMemberBankDetailsResponse,
	);
}
/** ********************* END FETCH MEMBER BANK DETAILS ******************** */

function* updateCorrectLoanStartEndDateForMember({ payload }: any) {
	try {
		const key = 'UpdateCorrectLoanStartEndDateForMemberKey';
		const {
			userID,
			companyID,
			databaseName,
			correctLoanGroupMemberID,
			loanGroupMemberID,
			loanIndexID,
			correctionType,
		} = payload;
		const jsonData = {
			CorrectLoanGroupMemberID: correctLoanGroupMemberID,
			LoanGroupMemberID: loanGroupMemberID,
			LoanIndexID: loanIndexID,
			CorrectionType: correctionType,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(correctLoanStartEndDateForMemberUpdate, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCorrectLoanStartEndDateForMemberFailure(responseData.data));
		} else {
			yield put(updateCorrectLoanStartEndDateForMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCorrectLoanStartEndDateForMemberFailure(error));
	}
}

function* resetUpdateCorrectLoanStartEndDateForMemberResponse() {
	yield put(updateCorrectLoanStartEndDateForMemberResponseChanged());
}

function* onUpdateCorrectLoanStartEndDateForMember() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_START,
		updateCorrectLoanStartEndDateForMember,
	);
}

function* onUpdateCorrectLoanStartEndDateForMemberResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_RESET,
		resetUpdateCorrectLoanStartEndDateForMemberResponse,
	);
}

function* updateCorrectLoanForOverallMember({ payload }: any) {
	try {
		const key = 'CorrectLoanForOverAllMemberKey';
		const {
			loanIndexID,
			loanIndexGroupMember,
			loanIndexDetails,
			userID,
			companyID,
			userName,
			databaseName,
			userAccessBranchID,
		} = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			LoanIndexGroupMember: loanIndexGroupMember,
			LoanIndexDetails: loanIndexDetails,
			CreatedBy: userID,
			UserName: userName,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(correctLoanForOverallMemberUpdate, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCorrectLoanForOverallMemberFailure(responseData.data));
		} else {
			yield put(updateCorrectLoanForOverallMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCorrectLoanForOverallMemberFailure(error));
	}
}

function* resetUpdateCorrectLoanForOverallMemberResponse() {
	yield put(updateCorrectLoanForOverallMemberResponseChanged());
}

function* onUpdateCorrectLoanForOverallMember() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_START,
		updateCorrectLoanForOverallMember,
	);
}

function* onUpdateCorrectLoanForOverallMemberResponseReset() {
	yield takeLatest(
		CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_RESET,
		resetUpdateCorrectLoanForOverallMemberResponse,
	);
}

export function* centerWiseLoanProposalSaga() {
	yield all([
		call(onCreateCenterWiseLoanProposal),
		call(onCreateCenterWiseLoanProposalResponseReset),
		call(onUpdateCenterWiseLoanProposal),
		call(onUpdateCenterWiseLoanProposalResponseReset),
		call(onFetchMembersListForCenterWiseLoanDetails),
		call(onFetchMembersListForCenterWiseLoanResponseReset),
		call(onFetchCenterWiseLoanProposalDetails),
		call(onFetchCenterWiseLoanProposalResponseReset),
		call(onAddMemberBankDetailsResponse),
		call(onAddMemberBankDetailsResponseReset),
		call(onFetchMemberBankDetailsResponse),
		call(onFetchMemberBankDetailsResponseReset),
		call(onUpdateCorrectLoanStartEndDateForMember),
		call(onUpdateCorrectLoanStartEndDateForMemberResponseReset),
		call(onUpdateCorrectLoanForOverallMember),
		call(onUpdateCorrectLoanForOverallMemberResponseReset),
	]);
}
